import { axiosInstance } from "helpers";

export async function getMaintenanceSetting(website_id) {
  return axiosInstance
    .get("allfeaturesettings", {
      params: {
        api_key: localStorage.getItem("apikey"),
        added_by: localStorage.getItem("user_id"),
        tab_hint: "Maintenance",
        website_id,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export async function getPagesList(website_id) {
  return axiosInstance
    .post("getFilteredPages", {
      api_key: localStorage.getItem("apikey"),
      website_id,
      data: {
        tags: {},
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export async function updateMaintenanceSetting({ website_id, data }) {
  return axiosInstance
    .post("updatefeaturesettings", {
      api_key: localStorage.getItem("apikey"),
      added_by: localStorage.getItem("user_id"),
      system_status: 0,
      website_id,
      tab_hint: "Maintenance",
      maintenance_settings: {
        ...data,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}
